"use client";
import useIsClient from "~/hooks/useIsClient";
import { BorderGlowFilter } from "./svg-filters";


export default function BorderGlowFilterClient() {
  const isClient = useIsClient();

  return isClient ? <BorderGlowFilter /> : null;
}
